<template>
  <div id="journalAccount">
    <div class="headerContent">
      <div class="contentWrap1">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          background-color="transparent"
          text-color="#fff"
          active-text-color="#fff"
          @select="handleSelect"
        >
          <el-menu-item index="0">资金系统流水</el-menu-item>
          <!-- <el-menu-item index="28">订单系统流水</el-menu-item> -->
          <el-menu-item index="32">现货系统流水</el-menu-item>
        </el-menu>
      </div>
    </div>
    <div class="tableWrap">
      <el-table :data="tableData" border style="width: 100%">
        <template slot="empty">
          <div class="no-datas1">
            <div
              class="no-data-img"
              style="margin: 100px auto 0px; width: 120px; height: 200px;"
            >
              <img
                src="../../../assets/images/no_data.png"
                alt=""
                style="width: 100%;"
              >
            </div>
          </div>
        </template>
        <el-table-column align="center" prop="flowId" label="流水号">
        </el-table-column>
        <el-table-column v-if="marketId == 0" align="center" label="类型">
          <template slot-scope="scope">
            <span>资金划转</span>
          </template>
        </el-table-column>
        <el-table-column v-else align="center" prop="bizName" label="类型">
        </el-table-column>
        <el-table-column align="center" prop="amount" label="发生额">
        </el-table-column>
        <el-table-column align="center" prop="balance" label="资金余额">
        </el-table-column>
        <el-table-column prop="occurTime" label="发生时间">
          <template slot-scope="scope">
            {{ scope.row.occurTime | dateFormate }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        popper-class='_popStyle'
        :current-page="pageData.currentPage"
        :page-sizes="pageData.pageSizes"
        :page-size="pageData.pageSize"
        layout="total, sizes, prev, pager, next"
        :total="pageData.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
/*global protocol http util */
// import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      marketId: 0,
      dataList: {},
      activeIndex: '0',
      tableData: [],
      pageData: {
        total: 0,
        pageSizes: [5, 10, 20],
        pageSize: 10,
        currentPage: 1
      }
    }
  },
  mounted() {
    this.queryMyIntegralDetailMArk0()
  },
  methods: {
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.queryMyIntegralDetail(this.marketId)
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.queryMyIntegralDetail(this.marketId)
    },
    queryMyIntegralDetail() {
      protocol.param_queryFirmAccountFundsFlow.param.page = this.pageData.currentPage - 1
      protocol.param_queryFirmAccountFundsFlow.param.size = this.pageData.pageSize
      protocol.param_queryFirmAccountFundsFlow.param.sort = [
        {
          direction: 'DESC', // "//DESC或ASC",
          property: 'occurTime' // "//排序属性"
        }]
      http.postFrontChange(protocol.param_queryFirmAccountFundsFlow, this.marketId).then(response => {
        const { code, message, value } = response.data
        if (code == '0') {
          if (value && code == '0') {
            this.pageData.total = value.totalElements
            const arr = value.content
            // 处理千分位分隔符，和小数点后两位
            arr.forEach(element => {
              element.amount = util.formatNum(element.amount)
              element.balance = util.formatNum(element.balance)
            })
            this.tableData = arr
          }
        } else {
          this.$message(message)
        }
      })
    },
    queryMyIntegralDetailMArk0() {
      protocol.param_queryFundsTransfer.param = {}
      protocol.param_queryFundsTransfer.param.page = this.pageData.currentPage - 1
      protocol.param_queryFundsTransfer.param.size = this.pageData.pageSize
      protocol.param_queryFundsTransfer.param.sort = [
        {
          direction: 'DESC', // "//DESC或ASC",
          property: 'occurTime' // "//排序属性"
        }]
      http.postFrontChange(protocol.param_queryFundsTransfer, 0).then(response => {
        const { code, message, value } = response.data
        if (code == '0') {
          if (value && code == '0') {
            this.pageData.total = value.totalElements
            const arr = value.content
            // 处理千分位分隔符，和小数点后两位
            arr.forEach(element => {
              element.amount = util.formatNum(element.amount)
              element.balance = util.formatNum(element.balance)
            })
            this.tableData = arr
          }
        } else {
          this.$message(message)
        }
      })
    },
    handleSelect(e) {
      this.pageData = {
        total: 0,
        pageSizes: [5, 10, 20],
        pageSize: 10,
        currentPage: 1
      }
      this.marketId = Number(e)
      if (this.marketId === 0) {
        this.queryMyIntegralDetailMArk0()
      } else {
        this.queryMyIntegralDetail()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
#journalAccount {
  .headerContent {
    height: 68px;
    line-height: 68px;
    margin: 20px 0;
    margin-bottom: 10px;
    background: linear-gradient(180deg, #1f243c 0%, #323855 100%);
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
    .contentWrap1 {
      p {
        padding-left: 20px;
        font-size: 20px;
        font-weight: 500;
        color: #fff;
      }
    }
  }
  .el-menu--horizontal > .el-menu-item {
    height: 68px;
    line-height: 68px;
  }
  .el-menu--horizontal > .el-menu-item.is-active {
    background-color: #2483ff !important;
  }
  .el-menu--horizontal .el-menu-item:not(.is-active):hover {
    background-color: rgb(38, 41, 65) !important;
  }
  .el-menu.el-menu--horizontal,
  .el-menu--horizontal > .el-menu-item {
    border-bottom: none;
  }
  .el-table{
    min-height: calc(100vh - 300px);
    background-color: #141625;
  }
}
</style>
